import { render, staticRenderFns } from "./systemNotification.vue?vue&type=template&id=7c46c23c"
import script from "./systemNotification.vue?vue&type=script&lang=js"
export * from "./systemNotification.vue?vue&type=script&lang=js"
import style0 from "./systemNotification.vue?vue&type=style&index=0&id=7c46c23c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports